import { Heading } from '@appsumo/dorado-react';
import Image from 'next/image';
import Link from 'next/link';
import { Button } from '~/components/ui';

/**
 * Thematic roadblock
 */
export const ThematicRoadblock = ({
  title,
  text,
  headline,
  backgroundColor,
  backgroundImage,
  logoImage,
  ctaText,
  ctaLink,
}: {
  /**
   * Title of collection
   */
  title: string;
  /**
   * Text to display (HTML allowed)
   */
  text: string;
  /**
   * Headline of the collection
   */
  headline?: string;
  /**
   * Background color
   */
  backgroundColor: string;
  /**
   * Image to display
   */
  backgroundImage: string;
  /**
   * Image for logo, badge, etc.
   */
  logoImage?: string;
  /**
   * CTA button text
   */
  ctaText: string;
  /**
   * CTA button link
   */
  ctaLink: string;
  /**
   * CTA button content
   */
  ctaContent?: string;
}) => {
  return (
    <Link href={ctaLink}>
      <div className="bg-email-capture" style={{ backgroundColor }}>
        <div className="flex min-h-[380px] flex-col items-stretch gap-6 px-4 py-6 sm:mx-auto sm:max-w-[1206px] sm:flex-row sm:gap-0 sm:py-6">
          <div className="flex shrink-0 items-center sm:basis-1/2 sm:px-4">
            <Image
              src={backgroundImage}
              width={281}
              height={500}
              unoptimized
              alt={title}
              className="aspect-video w-full object-cover"
            />
          </div>
          <div className="flex flex-col justify-center sm:basis-1/2 lg:px-10">
            <div className="flex flex-col gap-2">
              {logoImage && (
                <Image
                  src={logoImage}
                  role="presentation"
                  alt=""
                  width={180}
                  height={20}
                />
              )}
              <Heading.H1
                className="leading-10"
                dangerouslySetInnerHTML={{ __html: headline }}
              />
              <div
                className="mt-2"
                dangerouslySetInnerHTML={{ __html: text }}
              />
            </div>
            <Button
              href={ctaLink}
              className="mt-6 inline-block w-full text-center sm:w-fit"
            >
              {ctaText}
            </Button>
          </div>
        </div>
      </div>
    </Link>
  );
};
